import React from 'react';
import { CondensedSmall, Gutter, CondensedHeader, useApi } from '@axiom/ui';
import { CandidateYearsOfExperienceModel } from '@axiom/ui-models';
import type { Candidate } from '@axiom/validation';

import { TaxonomyApi } from '../../api/taxonomy-api';

type CandidateExperienceIndustrySummaryProps = {
  candidateIndustries: Candidate['industries'];
};

export const CandidateExperienceIndustrySummary = ({
  candidateIndustries,
}: CandidateExperienceIndustrySummaryProps) => {
  const [{ data: taxonomy }] = useApi(TaxonomyApi.readTaxonomy());

  return (
    <div data-test="INDUSTRY_EXPERIENCE_SUMMARY">
      <Gutter top="24px" right="16px" left="16px">
        <CondensedSmall name="INDUSTRY_EXPERIENCE_SUMMARY_HEADER">
          Industry Experience Summary
        </CondensedSmall>
        {candidateIndustries?.map(({ industryValue, yearsOfExperience }) => (
          <Gutter top="8px" key={industryValue}>
            <CondensedHeader name="INDUSTRY_SUMMARY_ITEM">
              <span data-test="NAME">
                {taxonomy.industries[industryValue]?.displayValue}
              </span>{' '}
              -{' '}
              <span data-test="YEARS_OF_EXPERIENCE">
                {new CandidateYearsOfExperienceModel(
                  yearsOfExperience
                ).formatYearsOfExperience()}
              </span>{' '}
              years
            </CondensedHeader>
          </Gutter>
        ))}
      </Gutter>
    </div>
  );
};
